<script setup>
import {ref, watch, computed} from 'vue'
import api from '@/services/api'
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    id: {
        type: Number,
        required: true
    },
    code: {
        type: String,
        default: ''
    }
})

const appStore = useAppStore()

const html = ref('')

const alphaMode = computed(() => appStore.alphaMode)

const renderTemplate = async () => {
    // Address the todo: Kill the process if alphaMode is off
    if (!alphaMode.value) {
        html.value = ''
        return
    }

    try {
        const response = await api.post(
            'api/template/render',
            {
                templateId: props.id,
                templateHtml: props.code
            },
            {
                headers: {
                    'X-Http-Method-Override': 'GET'
                }
            }
        )

        if (response?.data) {
            /** * Script to disable click events while preserving hover effects.
             * This prevents navigation attempts inside the preview iframe.
             */
            const clickDisableScript = `
                <script>
                    document.addEventListener('click', function(e) {
                        e.preventDefault();
                    }, true);
                <\/script>
            `

            html.value = clickDisableScript + response.data
        }
    } catch (error) {
        console.error("Preview render failed:", error)
        html.value = ''
    }
}

// Re-render when the ID or the code changes
watch(
    () => [props.id, props.code, alphaMode.value],
    () => {
        renderTemplate()
    },
    {immediate: true}
)
</script>

<template>
    <iframe v-if="html" :srcdoc="html"/>
    <div v-else class="themes-editor-preview-pane-ajax-loader-container">
        <img src="/ajax-loader.gif" alt="" class="themes-editor-preview-pane-ajax-loader">
    </div>
</template>